import {useCallback, useState} from "react";
import {platformAPI} from "../../../api/axiosConfig";
import {SirenMessageContent} from "../typedefs";
import {PaginatedResponseV2} from "../../../types/PaginatedResponse";
import {useQuery} from "react-query";
import {useAuth} from "../../../context/user";
import useDebouncer from "../../../hooks/debouncer";

type SirenMessageContentsResult = {
    results: SirenMessageContent[];
    hasMore: boolean;
    currentPage: number;
    pageSize: number;
}

export function useGetSirenMessageContents(clientID: string | null) {
    return useCallback(async (search: string, page: number): Promise<PaginatedResponseV2<SirenMessageContent> | null> => {
        const res = await platformAPI.get<SirenMessageContentsResult>("api/siren/message-contents", {
            params: {page, limit: 10, search, ...(clientID ? {clientID} : {})}
        })
        const {results, hasMore, currentPage} = res.data
        return {results, hasMore, currentPage}
    }, [clientID])
}

// Used by select dropdowns that need reactive search + loading state
export function useGetSirenMessageContentOptions(clientID: string | null) {
    const [search, setSearch] = useState("");
    const debouncedSearch = useDebouncer(search, 300);
    const auth = useAuth();

    const {data, isLoading} = useQuery(
        ["siren-message-content-options", clientID, debouncedSearch],
        async () => {
            const res = await platformAPI.get<SirenMessageContentsResult>("api/siren/message-contents", {
                params: {page: 1, limit: 100, search: debouncedSearch, clientID}
            })
            return res.data
        },
        {enabled: !!clientID || !auth.isSuperAdmin, cacheTime: 0}
    );

    return {data, setSearch, isLoading}
}
